// Adapted from snazzymaps.com
var elMapStyle = [
  { featureType: "water", elementType: "geometry", stylers: [{ color: "#333739" /*river*/ }] },
  { featureType: "landscape", elementType: "geometry", stylers: [{ color: "#9ec63f" /*landscape*/ }] },
  { featureType: "poi", stylers: [{ color: "#99c82c" /*buildings*/ }, { lightness: -7 }, { visibility: "off" }] },
  {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [{ color: "#6c8d1c" /*Main Roads*/ }, { lightness: -28 }],
  },
  {
    featureType: "road.arterial",
    elementType: "geometry",
    stylers: [{ color: "#83a434" /*MediumRoads*/ }, { visibility: "on" }, { lightness: -15 }],
  },
  {
    featureType: "road.local",
    elementType: "geometry",
    stylers: [{ color: "#91b639" /*LocalRoads*/ }, { lightness: -18 }],
  },
  { elementType: "labels.text.fill", stylers: [{ color: "#ffffff" }] },
  { elementType: "labels.text.stroke", stylers: [{ visibility: "off" }] },
  { featureType: "transit", elementType: "geometry", stylers: [{ color: "#2ecc71" }, { lightness: -34 }] },
  {
    featureType: "administrative",
    elementType: "geometry",
    stylers: [{ visibility: "on" }, { color: "#333739" }, { weight: 0.8 }],
  },
  { featureType: "poi.park", stylers: [{ color: "#cdff55" }] },
  {
    featureType: "road",
    elementType: "geometry.stroke",
    stylers: [{ color: "#333739" }, { weight: 0.3 }, { lightness: 10 }],
  },
];

el.hasStartedFetchingGoogleMaps = false;

// Google Maps calls this by name once its script has loaded (see loadGoogleMapsJs)
window.googleMapsJsLoaded = function () {
  jQuery.event.trigger("googleMapsJsLoaded");
};

el.MapView = function ($, domElement) {
  var map;
  var latLngBounds;
  var mapElement = $(domElement);

  this.init = function () {
    if (googleMapsLoaded()) {
      createMap();
    } else {
      el.MapView.loadGoogleMapsJs();
    }
  };

  el.documentElement.on("googleMapsJsLoaded", function () {
    createMap();
  });

  function createMap() {
    var markers = mapElement.find(".el-google-map-marker");

    var mapLatLng = convertStringToGoogleMapLatLng(mapElement.data("center"));
    var minZoom = mapElement.data("zoom");

    var options = {
      disableDefaultUI: true,
      center: mapLatLng,
      zoom: 15,
      mapTypeId: "Styled",
      scrollwheel: false,
    };

    try {
      map = new google.maps.Map(domElement, options);
    } catch (err) {
      $.log("Error initialising Google Maps", err);
      return;
    }

    var styledMapType = new google.maps.StyledMapType(elMapStyle, { name: "Styled" });
    map.mapTypes.set("Styled", styledMapType);

    var mwMapMarkerIcon = {
      anchor: new google.maps.Point(28, 87),
      //origin: new google.maps.Point(140, 1600),
      scaledSize: new google.maps.Size(72, 85),
      size: new google.maps.Size(72, 85),
      url: "/img/el-map-marker.png",
      optimized: false,
    };

    latLngBounds = new google.maps.LatLngBounds();

    $.each(markers, function (index, marker) {
      marker = $(marker);
      var latLng = convertStringToGoogleMapLatLng(marker.data("position"));
      var markerTitle = marker.data("title");

      new google.maps.Marker({
        map: map,
        position: latLng, //mwOfficeLatLng,
        icon: mwMapMarkerIcon,
        title: markerTitle,
      });

      latLngBounds.extend(latLng);
    });

    // Fit all markers at a minimum
    google.maps.event.addListener(map, "zoom_changed", function () {
      var zoomChangeBoundsListener = google.maps.event.addListener(map, "bounds_changed", function () {
        if (this.getZoom() > minZoom && this.initialZoom == true) {
          // Change max/min zoom here
          this.setZoom(minZoom);
          this.initialZoom = false;
        }
        google.maps.event.removeListener(zoomChangeBoundsListener);
      });
    });

    triggerLayout();

    setTimeout(function () {
      // This is required sometimes if we initialise the google map while it is within a display:none styled element
      triggerLayout();
    }, 1000);
  }

  function triggerLayout() {
    google.maps.event.trigger(map, "resize");
    map.initialZoom = true;
    map.setCenter(latLngBounds.getCenter());
    map.fitBounds(latLngBounds);
  }

  function googleMapsLoaded() {
    return typeof google === "object" && typeof google.maps === "object";
  }

  function convertStringToGoogleMapLatLng(coordString) {
    var coords = coordString.split(",");
    var lat = parseFloat(coords[0]);
    var lng = parseFloat(coords[1]);
    return new google.maps.LatLng(lat, lng);
  }

  el.MapView.loadGoogleMapsJs = function () {
    if (el.hasStartedFetchingGoogleMaps) {
      return;
    }
    el.hasStartedFetchingGoogleMaps = true;
    var script = document.createElement("script");
    script.type = "text/javascript";
    // For testing locally, you can use the old MW key, which you can find on the git history of this file
    script.src =
      "https://maps.googleapis.com/maps/api/js?key=" + el.CONFIG.googleMapsApiKey + "&callback=googleMapsJsLoaded";
    document.body.appendChild(script);
  };
};
